import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";


@Injectable({
  providedIn: 'root'
})

export class RenderSafeHtmlService {

  constructor(private sanitizer: DomSanitizer) {}
  
  renderSafeHtml(value: string, html: boolean = false) {
    if (html) {
      return this.sanitizer.bypassSecurityTrustHtml(value)
    }
    return value
  }
}
  